<template>
  <div id="app">
    <headertop></headertop>
    <div class="main">
      <h1><i class="el-icon-user"></i> 个人中心</h1>
      <br />
      <el-tabs tab-position="left" style="margin-top: 10px;">
        <el-tab-pane label="基本信息">
          <!-- 头像-->
          <el-form ref="form" label-width="120px">
            <el-form-item label="头像:">
              <el-avatar :src="info.img"></el-avatar>
              <el-upload class="right eidtbtn" ref="up_img"
                action=""
                accept="image/*"
                drag
                :auto-upload="false"
                :show-file-list="false"
                :on-change='change_img'>
                上传图片
              </el-upload>
            </el-form-item>

            <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
                  <div class="cropper-content">
                    <div class="cropper" style="text-align:center">
                    <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :fixed="option.fixed"
                        :fixedNumber="option.fixedNumber"
                        :centerBox="option.centerBox"
                        :infoTrue="option.infoTrue"
                        :fixedBox="option.fixedBox"
                        style="height: 10rem;"
                        :loading="option.loading"
                      ></vueCropper>
                    </div>
                  </div>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="finish" :loading="option.loading">确认</el-button>
                  </div>
                </el-dialog>


            <el-form-item label="公司名称:">
              <p>{{info.company}}</p>
            </el-form-item>

            <!-- 真实姓名-->
            <el-form-item label="真实姓名:">
              <p v-if="info.name_change_status==0">{{info.rale_name}}</p>
              <p v-else>{{info.rale_name}}【*】
                <span style="font-size: 0.625rem;">（【*】说明人员姓名经历过变更）</span>
              </p >
            </el-form-item>

            <!-- 用户名-->
            <el-form-item label="用户名:">
              <p>{{info.name}}</p>
              <el-button type="text" class="right eidtbtn" @click="edit_btn('name')">修改</el-button>
              <br />
              <div class="eidt" v-if="up_el_status.name">
                <el-input v-model.trim="save_data.name" placeholder="用户名"></el-input>
                <div class="right" >
                   <el-button size="small"  @click="up_el_status.name = false">取消</el-button>
                  <el-button type="primary" size="small" @click="save('name')">保存</el-button>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="微信绑定:">
              <span>
                <p v-if="info.wechat_status">已绑定</p>
                <p v-else>未绑定</p>
                <el-button v-if="info.wechat_status" type="text" class="right eidtbtn" @click="change_wechat('edit')">解绑</el-button>
                <el-button v-else type="text" class="right eidtbtn" @click="change_wechat('add')">绑定</el-button>
              </span>
            </el-form-item>

            <!-- 邮箱-->
            <el-form-item label="邮箱:">
              <p>{{info.mail}}</p>
              <el-button type="text" class="right eidtbtn" @click="edit_btn('mail')">更换</el-button>
              <br />
              <div class="eidt" v-if="up_el_status.mail">
                <el-input v-model.trim="save_data.mail" placeholder="邮箱"></el-input>
                <div>
                  <el-input v-model.trim="save_data.mail_code" placeholder="验证码">
                    <el-button type="primary" slot="append" @click="send_code('mail')">{{up_el_status.mail_code_text}}</el-button>
                  </el-input>
                  <div class="right" >
                     <el-button size="small"  @click="up_el_status.mail = false">取消</el-button>
                    <el-button type="primary" size="small" @click="save('mail')">保存</el-button>
                  </div>
                </div>
              </div>
            </el-form-item>

            <!-- 手机号-->
            <el-form-item label="手机号:">
              <p>{{info.phone}}</p>
              <el-button type="text" class="right eidtbtn" @click="edit_btn('phone')">更换</el-button>
              <br />
              <div class="eidt" v-if="up_el_status.phone">
                <el-input v-model.trim="save_data.phone" placeholder="手机号"></el-input>
                <div>
                  <el-input v-model.trim="save_data.phone_code" placeholder="验证码">
                    <el-button type="primary" slot="append" @click="send_code('phone')">{{up_el_status.phone_code_text}}</el-button>
                  </el-input>
                  <div class="right" >
                     <el-button size="small"  @click="up_el_status.phone = false">取消</el-button>
                    <el-button type="primary" size="small" @click="save('phone')">保存</el-button>
                  </div>
                </div>
              </div>
            </el-form-item>

          </el-form>

        </el-tab-pane>

        <el-tab-pane label="修改密码">
          <el-form ref="form" label-width="150px">
            <el-form-item label="旧密码:">
              <el-input v-model.trim="save_data.old" placeholder="旧密码" type="password" clearable></el-input>
            </el-form-item>
            <el-form-item label="新密码:">
              <el-input v-model.trim="save_data.pwd" placeholder="新密码" type="password" clearable></el-input>
            </el-form-item>
            <el-form-item label="再次确认新密码:">
              <el-input v-model.trim="save_data.pwd_re" placeholder="再次确认新密码" type="password" clearable></el-input>
            </el-form-item>
            <el-button type="primary" size="small" class="right" @click="save('pwd')">保存</el-button>
          </el-form>
        </el-tab-pane>
        <!--  -->
      </el-tabs>
    </div>
    <el-dialog :title="wechat_info.title" :visible.sync="wechat_info.show" width="24%" center>
      <wxlogin
        :appid="wechat_info.appid"
        :scope="'snsapi_login'"
        :theme="'black'"
        :redirect_uri="wechat_info.redirect_uri"
        >
      </wxlogin>
    </el-dialog>
    <footerbom></footerbom>
  </div>
</template>

<script>
  import Header from '../../../../components/index/public/visitor_NavHeader.vue'
  import Footer from '../../../../components/index/public/NavFooter.vue'
  import { VueCropper } from 'vue-cropper'
  import wxlogin from 'vue-wxlogin'

  export default {
    name: 'App',
    data() {
      return {
        wechat_info:{
          title:'',
          redirect_uri:'',
          show:false,
          appid:'wx76cc43001674cfe3'
        },
        dialogVisible: false,
              // 裁剪组件的基础配置option
              option: {
                img: '', // 裁剪图片的地址
                info: true, // 裁剪框的大小信息
                outputSize: 0.8, // 裁剪生成图片的质量
                outputType: 'jpeg', // 裁剪生成图片的格式
                canScale: false, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                // autoCropWidth: 300, // 默认生成截图框宽度
                // autoCropHeight: 200, // 默认生成截图框高度
                fixedBox: true, // 固定截图框大小 不允许改变
                fixed: true, // 是否开启截图框宽高固定比例
                fixedNumber: [5, 5], // 截图框的宽高比例
                full: true, // 是否输出原图比例的截图
                canMoveBox: false, // 截图框能否拖动
                original: false, // 上传图片按照原始比例渲染
                centerBox: true, // 截图框是否被限制在图片里面
                infoTrue: true ,// true 为展示真实输出图片宽高 false 展示看到的截图框宽高
                loading:false
              },
              picsList: [],  //页面显示的数组
        /* 基本信息*/
        info:{
          company:'',
          rale_name:'',
          name:'',
          img:'',
          phone:'',
          mail:'',
          name_change_status:'',
        },
        msg: {
          list:[],
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 10,
          msg_content:'消息内容',
          centerDialogVisible:false,
          search: '',
          button_show:true,
          selest_list:[],
        },
        up_el_status:{
          name:false,
          phone:false,
          phone_code_text:'获取验证码',
          mail:false,
          mail_code_text:'获取验证码',
          phone_last:60,
          mail_last:60,
          phone_timer:null,
          mail_timer:null,
        },
        save_data:{
          img:'',
          name:'',
          phone:'',
          phone_code:'',
          mail:'',
          mail_code:'',
          old:'',
          pwd:'',
          pwd_re:'',
          type:null,
        },
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer,
      wxlogin
    },
    mounted:function(){
      this.get_info();
      // this.get_msg();
      if(this.$route.query.code){
        this.check_wechat()
      }
    },
    methods: {
      change_wechat(type){
        let _this=this
        _this.wechat_info.type=type
        if(type=='edit'){
            _this.wechat_info.title='身份验证'
        }else{
          _this.wechat_info.title='微信绑定'
        }
        _this.wechat_info.redirect_uri=window.location.href
        _this.wechat_info.show=true
      },
      check_wechat(){
        let _this=this
        _this.axios.post('/v2/user/wechat_check',{data:_this.$route.query.code}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
            }else{
              _this.$message.error(res.data.msg)
            }
            _this.get_info()
            _this.$router.push('/personal')
          }else{
            _this.$message.error('服务器内部错误')
            _this.$router.push('/personal')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误');
          _this.$router.push('/personal')
        });
      },

      //消息的复选框事件
      handleSelectionChange(val) {
       this.msg.selest_list=val
      },

      selectable(row){
       if(row.status==0){
         return true
       }else{
         return false
       }
      },
      //消息的一键已读
      // msg_but(){
      //   let _this=this
      //   _this.axios.get('/v2/user/get_msg_info',{params:{num:'all'}}).then(function(res) {
      //     if(res.status=='200'){
      //       if(res.data.code=='1'){
      //         _this.$message.success(res.data.msg)
      //         _this.get_msg()
      //       }else{
      //         _this.$message.error(res.data.msg)
      //       }
      //     }else{
      //       _this.$message.error('服务器内部错误')
      //     }
      //   }).catch(function(error) {
      //     _this.$message.error('服务器内部错误')
      //   });
      // },
      change_img(event){
        let _this=this
        _this.$refs.up_img.clearFiles();
      	// 获取上传图片的本地url，用于上传前的本地预览
      	let url = '';
        url = window.URL.createObjectURL(event.raw);
      	if (window.createObjectURL != undefined) {
      		url = window.createObjectURL(event.raw);
      	} else if (window.URL != undefined) {
      		url = window.URL.createObjectURL(event.raw);
      	} else if (window.webkitURL != undefined) {
      		url = window.webkitURL.createObjectURL(event.raw);
      	}else{
          url = window.webkitURL.createObjectURL(event.raw);
        }
        _this.$nextTick(() => {
          _this.option.img = url;
          _this.dialogVisible = true
        })
      },
      finish(){
        let _this=this
        _this.$refs.cropper.getCropData((base64) => {
          _this.save_data.img=base64
          _this.save('img')
        })
      },
      /* 分页*/
      handleSizeChange(val) {
        this.msg.currentPage = 1;
        this.msg.pageSize = val;
      },
      handleCurrentChange(val) {
        this.msg.currentPage = val;
      },
      get_info(){
        let _this=this;
        _this.axios.get('/v2/user/get_info').then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.info=res.data.data
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      edit_btn(el){
        let _this=this;
        _this.up_el_status[el]=!_this.up_el_status[el]
      },
      change_info_check(type){
        let _this=this;
        if(_this.up_el_status[type+'_timer'] == null) {
          _this.up_el_status[type+'_timer'] = setInterval( () => {
            if(_this.up_el_status[type+'_last']>0){
              _this.up_el_status[type+'_code_text']=_this.up_el_status[type+'_last']+'s后重新获取';
              _this.up_el_status[type+'_last']--;
            }else{
              clearInterval(_this.up_el_status[type+'_timer']);
              _this.up_el_status[type+'_timer']=null;
              _this.up_el_status[type+'_last']=60;
              _this.up_el_status[type+'_code_text']='获取验证码';
            }
          }, 1000)
        }
      },
      send_code(type){
        let _this=this;
        if(_this.up_el_status[type+'_code_text']!='获取验证码'){
          return false;
        }
        _this.save_data.type=type
        _this.axios.post('/v2/user/send_code', {
          data: _this.save_data //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg);
              _this.change_info_check(type);
            }else{
              _this.$message.error(res.data.msg);
            }
          }else{
            _this.$message.error('服务器内部错误');
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误');
        });
      },
      save(type){
        let _this=this
        _this.save_data.type=type
        _this.axios.post('/v2/user/up', {
          data: _this.save_data //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              switch(type){
                case 'img':
                _this.dialogVisible = false;break
                case 'name':_this.up_el_status.name  = false;break
                case 'phone':_this.up_el_status.phone  = false;break;
                case 'mail':_this.up_el_status.mail  = false;break;
                case 'pwd':_this.up_el_status.pwd  = false;break;
              }
              _this.get_info()
              _this.save_change(type)
              _this.$message.success(res.data.msg)
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      save_change(type){
        let _this=this
        if(type=='img'){
          _this.save_data.img=''
        }
        if(type=='name'){
          _this.save_data.name=''
        }
        if(type=='phone'){
          _this.save_data.phone=''
          _this.save_data.phone_code=''
        }
        if(type=='mail'){
          _this.save_data.mail=''
          _this.save_data.mail_code=''
        }
        if(type=='pwd'){
          _this.save_data.old=''
          _this.save_data.pwd=''
          _this.save_data.pwd_re=''
        }
      },
      // get_msg(){
      //   let _this=this;
      //   _this.axios.get('/v2/user/get_msg').then(function(res) {
      //     if(res.status=='200'){
      //       if(res.data.code=='1'){
      //         _this.msg.list=res.data.data
      //         _this.msg.total=res.data.data.length
      //       }else{
      //         _this.$message.error(res.msg)
      //       }
      //     }else{
      //       _this.$message.error('服务器内部错误')
      //     }
      //   }).catch(function(error) {
      //     _this.$message.error('服务器内部错误')
      //   });
      // },
      // watch_msg(key,num){
      //   let _this=this;
      //   _this.axios.get('/v2/user/get_msg_info',{params:{num:num}}).then(function(res) {
      //     if(res.status=='200'){
      //       if(res.data.code=='1'){
      //         _this.msg.centerDialogVisible=true
      //         _this.msg.msg_content=res.data.msg
      //         _this.msg.list[key].status='1'
      //       }else{
      //         _this.$message.error(res.data.msg)
      //       }
      //     }else{
      //       _this.$message.error('服务器内部错误')
      //     }
      //   }).catch(function(error) {
      //     _this.$message.error('服务器内部错误')
      //   });
      // }
    }
  }
</script>

<style scoped>
  /deep/ .el-upload-dragger{
    border:0px;
    width: 100%;
    height: 100%;
  }
  .main {
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
  }

  h1 {
    margin: 20px;
  }

  >>>.el-tabs {
    width: 90%;
    margin: 0 5%;
  }

  >>>.el-form-item__label {
    padding-right: 30px;
  }

  .el-form-item .el-avatar {
    width: 100px;
    height: 100px;
  }

  .eidt .el-input {
    margin: 10px 0;
  }

  .el-form-item p {
    padding: 0;
    margin: 0;
    float: left;
    font-size: medium;
    font-weight: 600;
  }

  .eidtbtn {
    padding: 0 40px;
    line-height: 40px;
  }

  .eidt {
    border: 1px dashed #606266;
    padding: 20px;
    overflow: hidden;
    width: calc(100% - 42px);
  }

  /* 消息提醒 */
  >>>.el-alert {
    line-height: 20px;
    margin: 5px 0;
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/visitor/Mine/PersonalCenter/PersonalCenter.vue